module.exports = __webpack_public_path__ + "assets/img/578aaaf8e8e35e96608023bda68730ae.png";